const actions = {
  CHANGE_LAYOUT_MODE_BEGIN: 'CHANGE_LAYOUT_MODE_BEGIN',
  CHANGE_LAYOUT_MODE_SUCCESS: 'CHANGE_LAYOUT_MODE_SUCCESS',
  CHANGE_LAYOUT_MODE_ERR: 'CHANGE_LAYOUT_MODE_ERR',

  CHANGE_RTL_MODE_BEGIN: 'CHANGE_RTL_MODE_BEGIN',
  CHANGE_RTL_MODE_SUCCESS: 'CHANGE_RTL_MODE_SUCCESS',
  CHANGE_RTL_MODE_ERR: 'CHANGE_RTL_MODE_ERR',

  CHANGE_MENU_MODE_BEGIN: 'CHANGE_MENU_MODE_BEGIN',
  CHANGE_MENU_MODE_SUCCESS: 'CHANGE_MENU_MODE_SUCCESS',
  CHANGE_MENU_MODE_ERR: 'CHANGE_MENU_MODE_ERR',

  CHANGE_MENU_COLLAPSED_BEGIN: 'CHANGE_MENU_COLLAPSED_BEGIN',
  CHANGE_MENU_COLLAPSED_SUCCESS: 'CHANGE_MENU_COLLAPSED_SUCCESS',
  CHANGE_MENU_COLLAPSED_ERR: 'CHANGE_MENU_COLLAPSED_ERR',

  CHANGE_LANGUAGE_BEGIN: 'CHANGE_LANGUAGE_BEGIN',
  CHANGE_LANGUAGE_SUCCESS: 'CHANGE_LANGUAGE_SUCCESS',
  CHANGE_LANGUAGE_ERR: 'CHANGE_LANGUAGE_ERR',

  changeLayoutBegin: () => {
    return {
      type: actions.CHANGE_LAYOUT_MODE_BEGIN,
    };
  },

  changeLayoutSuccess: data => {
    return {
      type: actions.CHANGE_LAYOUT_MODE_SUCCESS,
      data,
    };
  },

  changeLayoutErr: err => {
    return {
      type: actions.CHANGE_LAYOUT_MODE_ERR,
      err,
    };
  },

  changeRtlBegin: () => {
    return {
      type: actions.CHANGE_RTL_MODE_BEGIN,
    };
  },

  changeRtlSuccess: data => {
    return {
      type: actions.CHANGE_RTL_MODE_SUCCESS,
      data,
    };
  },

  changeRtlErr: err => {
    return {
      type: actions.CHANGE_RTL_MODE_ERR,
      err,
    };
  },

  changeMenuBegin: () => {
    return {
      type: actions.CHANGE_MENU_MODE_BEGIN,
    };
  },

  changeMenuSuccess: data => {
    return {
      type: actions.CHANGE_MENU_MODE_SUCCESS,
      data,
    };
  },

  changeMenuErr: err => {
    return {
      type: actions.CHANGE_MENU_MODE_ERR,
      err,
    };
  },

  changeMenuCollapsedBegin: () => {
    return {
      type: actions.CHANGE_MENU_COLLAPSED_BEGIN,
    };
  },

  changeMenuCollapsedSuccess: data => {
    return {
      type: actions.CHANGE_MENU_COLLAPSED_SUCCESS,
      data,
    };
  },

  changeMenuCollapsedErr: err => {
    return {
      type: actions.CHANGE_MENU_COLLAPSED_ERR,
      err,
    };
  },

  changeLanguageBegin: () => {
    return {
      type: actions.CHANGE_LANGUAGE_BEGIN,
    };
  },

  changeLanguageSuccess: data => {
    return {
      type: actions.CHANGE_LANGUAGE_SUCCESS,
      data,
    };
  },

  changeLanguageErr: err => {
    return {
      type: actions.CHANGE_LANGUAGE_ERR,
      err,
    };
  },
};

export default actions;
